module.exports = __webpack_public_path__ + "img/conekta.7facb29c.svg";